import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import { reverse } from 'named-urls'
import { Button } from '@material-ui/core'

import useSnackbar from 'hooks/useSnackbar'

import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from 'components/Table'
import { MenuButton, Permitted, ConfirmationDialog } from 'components'

import helpers from 'helpers'
import * as service from 'service'

import { routes } from 'Routes'
import permissions from 'constants/permissions'

const PdcaTable = ({ setLoading, refresh, dataPdcas = [], loading }) => {
  const history = useHistory()
  const snackbar = useSnackbar()
  const [openDestroyed, setOpenDestroyed] = useState({
    open: false,
    pdcaId: null,
  })

  const { date } = helpers.formatters

  const redirect = (pdcaId, origin = 'show') =>
    history.push(reverse(routes.pdca[origin], { pdcaId }))

  const handleOpenModal = (pdcaId) =>
    setOpenDestroyed({
      open: true,
      pdcaId: pdcaId,
    })

  const handleCloseModal = () =>
    setOpenDestroyed({
      open: false,
      pdcaId: null,
    })

  const handleDelete = async () => {
    try {
      setLoading(true)
      await service.dponet.pdca.destroy({ pdcaId: openDestroyed?.pdcaId })
      refresh()
      snackbar.open({
        message: 'PDCA excluído com sucesso.',
        variant: 'success',
      })
    } catch (error) {
      snackbar.open({
        message:
          helpers.formatters.errorMessage(error, false) ||
          error?.error?.message,
        variant: 'error',
      })
    } finally {
      setLoading(false)
      handleCloseModal()
    }
  }

  return (
    <Table emptyMessage="Nenhum PDCA foi encontrado.">
      <TableHead>
        <TableRow>
          <TableCell width="5%">ID</TableCell>
          <TableCell width="25%">Nome</TableCell>
          <TableCell width="25%">Responsável</TableCell>
          <TableCell width="10%">Departamento</TableCell>
          <TableCell width="10%">Origem</TableCell>
          <TableCell width="10%">Início</TableCell>
          <TableCell width="10%">Término</TableCell>
          <TableCell align="center" width="5%">
            Ações
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {dataPdcas?.map((dataPdca) => (
          <TableRow key={dataPdca?.id}>
            <TableCell>#{dataPdca?.id}</TableCell>
            <TableCell>{dataPdca?.name}</TableCell>
            <TableCell>{dataPdca?.responsibleUser?.name || '-'}</TableCell>
            <TableCell>{dataPdca?.department?.name || '-'}</TableCell>
            <TableCell>{dataPdca?.origin || '-'}</TableCell>
            <TableCell align="center">{date(dataPdca?.startDate)}</TableCell>
            <TableCell align="center">{date(dataPdca?.endDate)}</TableCell>
            <TableCell align="center" size="small">
              <MenuButton>
                <Permitted tag={permissions.MONITORING_MANAGEMENT_PDCA.MANAGE}>
                  <Button
                    color="secondary"
                    fullWidth
                    size="small"
                    onClick={() => redirect(dataPdca?.id, 'show')}
                  >
                    Detalhes
                  </Button>
                  <Button
                    color="secondary"
                    fullWidth
                    size="small"
                    onClick={() => redirect(dataPdca?.id, 'edit')}
                  >
                    Editar
                  </Button>
                  <Button
                    color="secondary"
                    fullWidth
                    size="small"
                    onClick={() => handleOpenModal(dataPdca?.id)}
                    disabled={openDestroyed?.open}
                  >
                    Excluir
                  </Button>
                </Permitted>
              </MenuButton>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
      {openDestroyed?.open && (
        <ConfirmationDialog
          open={openDestroyed?.open}
          setOpen={handleCloseModal}
          textButton="Confirmar"
          actionAcceptButton={handleDelete}
          text="Tem certeza que deseja excluir este PDCA? Essa ação não pode ser desfeita."
          loading={loading}
        />
      )}
    </Table>
  )
}

export default PdcaTable
